export default __webpack_public_path__ + "static/media/advicegradissuegfx-13.af0bb089.png";